import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import routes from './routes';
import axios from 'axios'

Vue.use(VueRouter);

Vue.prototype.navigateTo = function(link) {
	this.$router.push(link, () => {});
};
Vue.prototype.navigateBack = function(timeout) {
	setTimeout(() => {
		this.$router.go(-1);
	}, timeout ? typeof timeout == 'boolean' ? 1000 : timeout : 0);
};
Vue.prototype.redirectTo = function(link) {
	this.$router.replace(link);
};
Vue.prototype.keepAliveTo = function(link) {
	this.getAlive().include(this.$route.name, () => {
		this.navigateTo(link);
	});
};

Vue.prototype.mp = {
	navigateTo(path, query) {
		mpRouter('navigateTo', path, query);
	},
	navigateBack(timeout) {
		if (store.state.ENV != 'mp') {
			$app.navigateBack(timeout);
			return;
		}

		setTimeout(() => {
			wx.miniProgram.navigateBack({
				delta: -1
			});
		}, timeout ? typeof timeout == 'boolean' ? 1000 : timeout : 0);
	},
	redirectTo(path, query) {
		mpRouter('redirectTo', path, query);
	},
	reLaunch(path, query) {
		mpRouter('reLaunch', path, query);
	},
	navigateWeb(url, query = {}) {
		if (window._fromRoute == $app.$router.resolve({path: url, query}).href) {
			$app.mp.navigateBack();
		} else {
			if (store.state.ENV == 'mp') {
				query._from = $app.$route.fullPath;
			}
			mpWebview(url, query, 'navigateTo');
		}
	},
	redirectWeb(url, query = {}) {
		if (window._fromRoute == $app.$router.resolve({path: url, query}).href) {
			$app.mp.navigateBack();
		} else {
			if (window._fromRoute && store.state.ENV == 'mp') {
				query._from = window._fromRoute;
			}
			mpWebview(url, query, 'redirectTo');
		}
	},
	reLaunchWeb(url, query) {
		mpWebview(url, query, 'reLaunch');
	}
}

function mpRouter(type, url, data = {}) {
	let param = [];
	for (let i in data) {
		if (data[i] !== undefined && data[i] !== null) {
			param.push(`${i}=${typeof data[i] === 'object' ? JSON.stringify(data[i]) : data[i]}`);
		}
	}

	wx.miniProgram[type]({
		url: `${url}?${param.join('&')}`
	});
}

function mpWebview(url, query, type) {
	if (store.state.ENV != 'mp') {
		$app[type]({
			path: url,
			query
		});
		return;
	}
	
	if (typeof url == 'object') {
		query = url;
		url = '';
	} else {
		query = {
			[url.indexOf('http') == 0 ? 'url' : 'path']: url,
			query: query ? encodeURIComponent(JSON.stringify(query)) : ''
		}
	}
	mpRouter(type, '/pages/webview/index', query);
}

const router = new VueRouter({
	mode: 'history',
	base: '/',
	linkActiveClass: 'z-active',
	linkExactActiveClass: 'z-exact',
	routes
});

const app = new Vue();
router.beforeEach((to, from, next) => {
	if (!to.hash) {
		axios.get(`//${window.location.host}/version.json?t=${new Date().getTime()}`).then(res => {
			if (res.status === 200) {
				if (window.sysVersion && window.sysVersion != res.data.version) {
					app.$confirm({
						message: '检测到新版本已发布，请重新打开小程序后使用',
						buttonName: '重新打开',
						cancelButton: false,
						resolve: () => {
							app.mp.reLaunch('/pages/entry');
						}
					});
				} else {
					window.sysVersion = res.data.version;
				}
			}
		}).catch(e => {
			console.log(e);
		});
	}

	if (false && !to.meta.loginFree) {
		if (!store.state.session) {
			next(`/login?redirect=${to.fullPath}`);
		} else if (to.name && !to.meta.authFree && !app.auth(to.name)) {
			next('/');
		} else {
			next();
		}
	} else {
		next();
	}
});

export default router